// extracted by mini-css-extract-plugin
export default {"root":"BasicButton_root__Y6Olm"};